<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.recruitment"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.recruitment"),
            items: [
                {
                    text: i18n.t("module.recruitment"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'Candidate',
                    label: i18n.t('module.candidate'),
                    icon: 'mdi-account-multiple',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'CandidateJob',
                    label: i18n.t('module.job'),
                    icon: 'mdi-briefcase-outline',
                    color: 'primary',
                    core: true,
                },
                {
                    route: 'CandidateStatus',
                    label: i18n.t('module.candidateStatus'),
                    icon: 'mdi-account-tie',
                    color: 'success',
                    core: false,
                },
                {
                    route: 'Position',
                    label: i18n.t('module.position'),
                    icon: 'mdi-badge-account',
                    color: 'warning',
                    core: false,
                },
            ],
        };
    },
}
</script>